export function Keyword<T>(value: string, object: any, fallback?: any): T {
  return object[value] ?? fallback ?? object[Object.keys(object)[0]]
}
